import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import Router from 'vue-router'
import store from './store'
// import Antd from 'ant-design-vue' // 引入Ant Design Vue组件
// import 'core-js/stable' // 引入Ant Design Vue样式
// import 'ant-design-vue/dist/antd.css' 
import 'regenerator-runtime/runtime'
import ElementUI from 'element-ui';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';  // 引入axios
import './style.less' // 引入全局样式
import commonUtil from './utils/index'
import * as customFilter from '@/filters/filters';
import { Message } from 'element-ui';
Vue.prototype.$message = Message;

//全局注册，使用方法为:this.$axios
Vue.prototype.$axios = axios
// 全局追加token
axios.interceptors.request.use((config) => {
    if (['Login', 'Register'].indexOf(config.url) === -1) {
        const token = sessionStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const currentSystemStr = sessionStorage.getItem('currentSystem');
        if(currentSystemStr){
            const systemCode = JSON.parse(currentSystemStr).code;
            if (config.headers['Content-Type'] === 'multipart/form-data;charset=UTF-8'){
                config.data.append('systemCode', systemCode);
            }else{
                if (config.method === 'post' || config.method === 'put') {
                    config.data = {
                        ...config.data,
                        systemCode: systemCode
                    }
                }else{
                    config.params = {
                        ...config.params,
                        systemCode: systemCode
                    }
                }
            }
        }
        return config;
    }
});

Vue.use(VueI18n)

Vue.config.productionTip = false
const locale = sessionStorage.getItem('locale');
const i18n = new VueI18n({
    locale: locale ? locale : (navigator.language) ? navigator.language : navigator.userLanguage,
    messages: {
        'zh': Object.assign(require('@/assets/languages/zh.json'), zhLocale),
        'en': Object.assign(require('@/assets/languages/en.json'), enLocale)
        // 'zh': Object.assign(require('@/assets/languages/zh.json'), zhLocale),
        // 'en': Object.assign(require('@/assets/languages/en.json'), enLocale)
        // 'zh': Object.assign(require('@/assets/cui/zh.json'), zhLocale),
        // 'en': Object.assign(require('@/assets/cui/en.json'), enLocale)
    },
    // 去除翻译错误警告
    silentTranslationWarn: true
});
//挂载到vue中
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});

Vue.use(commonUtil);

Object.keys(customFilter).forEach(item => {
    Vue.filter(item, customFilter[item])
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');

// 封装默认class
const notify = option =>
    Notification(Object.assign({ customClass: 'largeMessageStyle' }, option));
const $message = option =>
    Message(Object.assign({ customClass: 'largeMessageStyle' }, option));
const optionsBox = (options, type) => {
    if (typeof options === 'string') {
        options = { message: options }
    }
    options.type = type;
    return options
};
let typeArr = ['success', 'warning', 'info', 'error'];
Object.keys(Notification).forEach(type => {
    if (typeArr.includes(type)) {
        notify[type] = options => notify(optionsBox(options, type));
        $message[type] = options => $message(optionsBox(options, type))
    } else {
        notify[type] = Notification[type];
        $message[type] = Message[type]
    }
});

Vue.prototype.$notify = notify;
Vue.prototype.$message = $message;

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {

    return originalPush.call(this, location).catch((err) => err);

};